import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FiltersDisplay } from 'customer-data-filters-ui/public/components';
import { toPropertyBasicType } from '../../../../../dataset/type-utils';
//@ts-expect-error Untyped import
import DeletedPropertyFilterLabel from '../property-filter/DeletedPropertyFilterLabel';
import PropertyFilterDisplayLabel from '../property-filter/PropertyFilterDisplayLabel';
import { Field } from '../../../../schema/column-records';
//@ts-expect-error Untyped import
import { useField, useSourceMeta } from '../SourceMeta';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useFilterTypeContext } from '../FilterTypeContext';
import { Expression } from '../../../../../dataset/expression-records';
import { useDatasetFilterStrategy } from '../../strategies/use-dataset-strategy';
import { transformToFilterBranch } from '../../../../utils/filter-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FieldOperatorDisplayView = ({
  filter,
  datasetField
}) => {
  const sourceMeta = useSourceMeta();
  const strategy = useDatasetFilterStrategy({
    source: sourceMeta
  });
  // Check if operation is null/undefined
  const hasOperation = filter.filter && filter.filter.get('operation');
  if (!hasOperation) {
    return null;
  }
  const filtersDisplayValue = transformToFilterBranch(filter, datasetField.name);
  if (!strategy || !filtersDisplayValue) {
    return /*#__PURE__*/_jsx(Text, {
      as: "h6",
      children: /*#__PURE__*/_jsx("strong", {
        children: datasetField.label
      })
    });
  }
  return /*#__PURE__*/_jsx(FiltersDisplay, {
    baseFilterFamily: '0-1',
    strategy: strategy,
    value: filtersDisplayValue
  });
};
const FieldFilterDisplayLabel = ({
  filter
}) => {
  const {
    field
  } = filter;
  const datasetField = useField(field.name);
  const sourceMeta = useSourceMeta();
  const {
    context
  } = useFilterTypeContext();
  if (!datasetField.derived) {
    const expression = Expression(datasetField.expression);
    const propertyFilter = filter.set('field', Field({
      name: expression.name,
      table: expression.table,
      type: datasetField.type.propertyType
    }));
    const propertyExists = sourceMeta && !!sourceMeta.datasetMeta.properties.getIn([expression.table, expression.name]);
    if (!propertyExists) {
      return /*#__PURE__*/_jsx(DeletedPropertyFilterLabel, {
        filter: propertyFilter
      });
    }
    return /*#__PURE__*/_jsx(PropertyFilterDisplayLabel, {
      filter: propertyFilter
    });
  }
  const sameFieldType = toPropertyBasicType(datasetField.type) === field.type;
  const isValidContext = context === 'AGGREGATE' ? datasetField.context === 'AGGREGATE' || datasetField.input.includes('FIXED') : context === 'GROUPED_SUMMARY' ? datasetField.context === 'AGGREGATE' : datasetField.context === 'ROW_LEVEL' || datasetField.context === 'CONSTANT';
  const isValid = datasetField.valid && sameFieldType && isValidContext;
  let invalidFilterMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-snowflake.filter-editor.dataset-field.invalid"
  });
  if (!sameFieldType) {
    invalidFilterMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-snowflake.filter-editor.dataset-field.field-type-changed"
    });
  } else if (!isValidContext) {
    invalidFilterMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-snowflake.filter-editor.dataset-field.context-changed"
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "dataset-field-filter-display-label",
    children: [/*#__PURE__*/_jsx(Text, {
      display: "block",
      as: "h6",
      children: I18n.text('reporting-snowflake.filter-editor.dataset-field.label')
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: invalidFilterMessage,
      disabled: isValid,
      children: /*#__PURE__*/_jsxs(Text, {
        color: !isValid ? 'text-alert-default' : 'text-core-default',
        children: [/*#__PURE__*/_jsx(Text, {
          display: "block",
          as: "h6",
          children: datasetField.label || datasetField.name
        }), /*#__PURE__*/_jsx(FieldOperatorDisplayView, {
          filter: filter,
          datasetField: datasetField
        })]
      })
    })]
  });
};
export default FieldFilterDisplayLabel;